import React from 'react';
import AsyncSmb from '../smb/index';
import {Route, Navigate} from 'react-router-dom';

export default [
  <Route
    key="/business/solutions/online-service/eye-wear/:type?"
    path="business/solutions/online-service/eye-wear/:type?"
    element={<AsyncSmb />}
  />,
  <Route
    key="/business/solutions/online-service/skincare-pro/:type?"
    path="business/solutions/online-service/skincare-pro/:type?"
    element={<AsyncSmb />}
  />,
  <Route
    key="/business/solutions/online-service/makeup/:type?"
    path="business/solutions/online-service/makeup/:type?"
    element={<AsyncSmb />}
  />,
  <Route
    key="/business/solutions/online-service/aesthetic-simulation/:type?"
    path="business/solutions/online-service/aesthetic-simulation/:type?"
    element={<AsyncSmb />}
  />,
  <Route
    key="/business/solutions/online-service"
    path="business/solutions/online-service"
    element={<Navigate to="../business/solutions/online-service/makeup" replace />}
  />,
];
